'use client';

import { useMemo } from 'react';

import type { NavItem } from '../../types/navigation';

const useHeaderActiveItem = (navItems: NavItem[], openDropdown: string | null) =>
  useMemo(
    () => navItems.find((item) => item.label === openDropdown) || null,
    [navItems, openDropdown],
  );

export default useHeaderActiveItem;
